import { create } from "zustand";
import teamService from "../services/team.service";
import { TeamStoreProps } from "../types/team.type";

const teamStore = create<TeamStoreProps>((set) => ({
  // Loading
  loading: true,
  setLoading: (loading) => set((state) => ({
    ...state,
    loading,
  })),
  toggleLoading: () => set((state) => ({
    ...state,
    loading: !state.loading,
  })),

  // Error
  error: false,
  setError: (error) => set((state) => ({
    ...state,
    error,
  })),
  toggleError: () => set((state) => ({
    ...state,
    error: !state.error,
  })),
  errorMessage: '',
  setErrorMessage: (errorMessage) => set((state) => ({
    ...state,
    errorMessage
  })),

  // Team data
  team: undefined,
  setTeam: (newTeam) => set((state) => ({
    ...state,
    loading: false,
    team: newTeam
  })),
  fetchTeam: async () => {
    set((state) => ({ 
      ...state, 
      loading: true, 
    }))
    const response = await teamService.get({})
    if (response.code !== '200') {
      localStorage.clear()
      return
    }
    set((state) => ({ 
      ...state, 
      error: false, 
      loading: false, 
      errorMessage: '',
      team: response.data
    }))
  }
}))

export default teamStore